import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux';
import withRouter from 'components/components/common/withRouter';
import InputForm from 'components/components/common/forms/InputForm';
import { Error } from 'components/common/Form.js';
import CustomerPhoneNumberValidation from 'components/components/auth/utils/CustomerPhoneNumberValidation';
import CustomerBasicDataValidation from 'components/components/auth/utils/CustomerBasicDataValidation';
import { setBookingUserData, toggleCreateAccountInBooking, setUserDataErrors } from 'components/actions/bookingActions';
import PasswordMask from 'components/components/common/PasswordMask';
import { withStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import styles from '../../../common/customStylesRadioButton';
import InputPhoneNr from 'components/components/common/forms/InputPhoneNr';
import axios from 'components/AppRequest';
import _ from 'lodash';
import LoadingSpinner from 'components/components/common/LoadingSpinner';
import TransHelper from 'components/common/translations/TransHelper';

function SampleEyeShow() {
  return (
    <FontAwesomeIcon
      icon={['fas', 'eye']}
      title="Show"
    />
  );
}

function SampleEyeHide() {
  return (
    <FontAwesomeIcon
      icon={['fas', 'eye-slash']}
      title="Hide"
    />
  );
}

class RegisterForm extends Component {
  constructor(props, context) {
    super(props, context);
    this.cbdv = new CustomerBasicDataValidation(true, this.props.locale);
    this.inputPhoneRef = React.createRef();
  }

  state = {
    isLoading: false
  }

  changePhoneNumber = (value) => {
    this.props.setBookingUserData("phone", value);
  }

  changeName = (e) => {
    var value = e.target.value;
    this.props.setBookingUserData("name", value);
  }

  changeEmail = (e) => {
    var value = e.target.value;
    this.props.setBookingUserData("email", value);
  }

  changePassword = (e) => {
    var value = e.target.value;
    this.props.setBookingUserData("password", value);
  }

  changePhoneCountry = (phoneCountryValue) => {
    this.props.setBookingUserData("phoneCountry", phoneCountryValue);
  }

  goNext = (e) => {
    e.preventDefault();
    this.props.setUserDataErrors(null, true);

    if (!this.cbdv.isValidForm(this.props.userData) ||
      this.inputPhoneRef.current.validateForm() !== null
    ) {
      //merge errors from two helper classes
      var errors = { phone: this.inputPhoneRef.current.validateForm() };
      _.merge(errors, this.cbdv.getFieldsErrors(this.props.userData));
      this.props.setUserDataErrors(errors);
      return;
    }
    const { phoneCountry, phone, createAccountWithBooking, email,
      phoneConfirmed } = this.props.userData;

    if (createAccountWithBooking) {
      //check phone number was confirmed already
      if (phoneConfirmed) {
        TransHelper.redirect(this.props, 'routes.url.summary');
        return;
      }

      //show loading button
      this.setState({ isLoading: true }, () => {
        //validate data on server and send sms, next go to phone verification
        var wholePhone = phoneCountry.label + phone;
        var params = { phone: wholePhone, email: email };
        axios.post('/pwa/registration/check-email-and-phone', params)
          .then(response => {
            TransHelper.redirect(this.props, 'routes.url.confirmPhone');
          })
          .catch(err => {
            console.log("err", err.response);
            this.setState({ isLoading: false });
            this.props.setUserDataErrors(err.response.data.errors);
          });
      });
    } else {
      //go to the next step
      TransHelper.redirect(this.props, 'routes.url.summary');
    }
  }

  trans = (key, pref = "content.userData.registerForm") => {
    return TransHelper.translate(this.props.locale, pref + "." + key);
  }

  render() {
    const { name, email, password, errors, createAccountWithBooking }
      = this.props.userData;

    return (
      <form>
        <fieldset>
          <legend className="visuallyhidden">Personal Info Form</legend>
          <p className="text-center" style={{ margin: '-20px 0 30px' }}>
            {this.trans('accountInfo')}<a onClick={this.props.toggleFormState} href="">{this.trans('logIn')}</a>
          </p>
          <ul className="list-fields list-none">
            <li className="list-fields__item">
              <InputForm
                id="fullname"
                name="_fullname_pks"
                type="text"
                label={this.trans('labels.fullname')}
                value={name}
                handleChange={this.changeName}
              />
              <Error error={errors.name} />
            </li>

            <li className="list-fields__item">
              <InputForm
                id="email"
                name="_email_pks"
                type="email"
                label={this.trans('labels.email')}
                value={email}
                handleChange={this.changeEmail}
              />
              <Error error={errors.email} />
            </li>

            <li className="list-fields__item">
              <InputPhoneNr
                locale={this.props.locale}
                ref={this.inputPhoneRef}
                changePhoneCountry={this.changePhoneCountry}
                changePhoneNumber={this.changePhoneNumber}
                errorPhone={errors.phone}
                phoneNumber={this.props.userData.phone}
                phoneCountry={this.props.userData.phoneCountry}
              />
            </li>
          </ul>

          <div className="create-account">
            <label htmlFor="create-account" className="text-normal">
              <Checkbox
                id="create-account"
                checked={createAccountWithBooking}
                onChange={() => this.props.toggleCreateAccountInBooking()}
                classes={{
                  root: this.props.classes.root,
                  checked: this.props.classes.checked,
                }}
                className="checkbox-button"
                name="create-account"
              />
              {this.trans('createAccount')}
            </label>
            {createAccountWithBooking &&
              <ul className="list-fields list-none">
                <li className="list-fields__item">
                  <label htmlFor="password">{this.trans('labels.password')}</label>
                  <PasswordMask
                    id="password"
                    name="password"
                    value={password}
                    onChange={this.changePassword}
                    showButtonContent={<SampleEyeShow />}
                    hideButtonContent={<SampleEyeHide />}
                    buttonClassName="button--toggle"
                    className="button-toggle-wrap"
                  />
                  <Error error={errors.password} />
                </li>
              </ul>
            }
          </div>
          <Error error={errors.sms} />
          {this.state.isLoading
            ?
            <LoadingSpinner className="button button--outline button--expand" />
            :
            <button
              className="button button--outline button--expand"
              onClick={this.goNext}
            >
              {this.trans('next', 'content.common')}
            </button>
          }
        </fieldset>
      </form>

    );
  }
}

const mapStateToProps = (state) => {
  return {
    userData: state.booking.userData,
    childrenNumber: state.booking.childrenNumber,
    isLogged: state.app.isLogged,
    departureAddress: state.booking.departureAddress,
    returnAddress: state.booking.returnAddress,
  };
};

const mapDispatchToProps = {
  setBookingUserData, toggleCreateAccountInBooking, setUserDataErrors
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)
    (withStyles(styles)(RegisterForm))
);